import cn from 'clsx';
import React from 'react';

import styles from './LinearProgress.module.css';

type Props = {
  position?: 'absolute' | 'relative';
};

export const LinearProgress: React.FC<Props> = ({ position = 'relative' }) => {
  return (
    <div className={cn(styles.root, styles[position])}>
      <div className={styles.line}></div>
    </div>
  );
};
